<template>
<div>
  <div class="title-bar title-h3">{{selectTitle}}</div>
  <hr class="mr-b20">
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <h4>감시 파일 목록</h4>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="addChangeFileList"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!isDeleted" @click="deleteChangeFile"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div>
      <el-button :disabled="!isDeleted" size="small" type="primary" @click="saveGroup">그룹저장</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper row-class-name="c-dblclick" :data="dataList" :columns="fileDetectColumns" :column-default="columnDefault" @selection-change="detectChangeSelection"
    :pagination="true" :show-custom-header="true" :show-search-tool="showSearchTool" @row-dblclick="editChangeFileList" style="width:100%;">
    <template slot-scope="scope" slot="checkbox-slot">
      <el-checkbox :value="scope.row.detectTimeApply" true-label="Y" false-label="N" />
    </template>
  </el-table-wrapper>
  <w-file-change-popup ref="fileChangePopup" :selectPhysicalNode="selectPhysicalNode" @reload-data="loadData" :popup-type="changePopupType" :editRow="editRow"></w-file-change-popup>
  <w-file-change-group-save-popup ref="fileChangeGroupSavePopup" :changeCheckList="changeCheckList" @reload-data="loadData"></w-file-change-group-save-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import cloneDeep from 'lodash/cloneDeep';
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import WFileChangePopup from '@/views/settings/server/FileDetectSettings/FileChangeDetectView/popup/FileChangePopup';
import WFileChangeGroupSavePopup from '@/views/settings/server/FileDetectSettings/FileChangeDetectView/popup/FileChangeGroupSavePopup';

export default {
  name: 'WDetectListView',
  components: {
    WFileChangePopup,
    WFileChangeGroupSavePopup,
  },
  props: {
    selectPhysicalNode: Object,
  },
  data() {
    return {
      columnDefault,
      changePopupType: null,
      selectTitle: '',
      isDeleted: false,
      dataList: null,
      showSearchTool: false,
      serverId: null,
      editRow: {},
      changeCheckList: [],
      fileDetectColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'path',
          label: '디렉토리 경로',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'fileName',
          label: '파일명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'detectFileSize',
          label: '감시 주기 설정 (초)',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'detectTimeApply',
          label: '감시 구간 설정',
          sortable: true,
          scopedSlot: 'checkbox-slot',
          filters: [
            {
              text: '설정',
              value: 'Y',
            },
            {
              text: '미설정',
              value: 'N',
            },
          ],
        },
        {
          prop: 'detectStarttime',
          label: '구간 시작 시간',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'detectEndtime',
          label: '구간 종료 시간',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type === 'obj') {
          this.serverId = this.selectPhysicalNode.serverId;
          this.selectTitle = `[${this.selectPhysicalNode.label}] 파일 변경/미변경 감시`;
          this.loadData();
        }
      },
      immediate: true,
    },
    changeCheckList: {
      handler() {
        if (this.changeCheckList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      ServerSettingAPI.getFileChangeDetectList({ serverId: this.serverId }).then((response) => {
        if (response.data.success) {
          this.dataList = response.data.data;
        }
      });
    },
    /**
     * [editChangeFileList 서버 설정 > 파일 감시 > 파일 변경/미변경 감시 목록의 항목을 수정하는 팝업을 띄운다.]
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    editChangeFileList(row) {
      this.editRow = cloneDeep(row);
      // 수정하고자 하는 항목이 패턴형 로그파일인 경우
      // 가지고 있는 path의 값을 pattern을 기준으로 패턴 앞과 패턴 뒤를 구분하여 팝업으로 띄운다.
      if (row.patternFlag === 'Y') {
        const convertPath = cloneDeep(row.path.replace(/\\/gi, '/'));
        const splitPattern = convertPath.split(`${row.pattern}`);
        this.editRow.beforePattern = splitPattern[0];
        this.editRow.afterPattern = splitPattern[1];
      }
      this.changePopupType = 'EDIT';
      this.$refs.fileChangePopup.open();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [addChangeFileList 서버 설정 > 파일 감시 > 파일 변경/미변경 감시 목록에서 체크된 항목을 리스트에 추가한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    detectChangeSelection(selectVal) {
      this.changeCheckList = selectVal;
    },
    /**
     * [addChangeFileList 서버 설정 > 파일 감시 > 파일 변경/미변경 감시 목록 항목을 추가한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    addChangeFileList() {
      this.editRow = {};
      this.changePopupType = 'ADD';
      this.$refs.fileChangePopup.open();
    },
    /**
     * [deleteChangeFile 서버 설정 > 파일 감시 > 파일 변경/미변경 감시 목록의 선택된 항목을 삭제한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    deleteChangeFile() {
      const target = '감시 파일 ';
      const action = msgUtil.action.DELETE;

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        ServerSettingAPI.deleteBulkFileDetectDir(this.changeCheckList).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    /**
     * [saveGroup 서버 설정 > 파일 감시 > 파일 변경/미변경 감시 > 그룹 저장]
     * @author yelim
     * @return {[type]} [description]
     */
    saveGroup() {
      this.$refs.fileChangeGroupSavePopup.open();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/FileDetectSettings/FileChangeDetectView/component/FileChangeListView.vue